import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./AttestText.module.css";

export default function AttestPage() {

    const { t } = useTranslation("login");

    return (<>
        <div className="auth-home-top-content">
            <div className={styles.AttestContent}>
                <h2>
                    {t("6-attest-link")}
                </h2>
                <p>
                    {t('6-attest-1')}
                </p>
                <p>
                    {t('6-attest-2')}
                </p>
                <p>
                    {t('6-attest-3')}
                </p>
                <p>
                    {t('6-attest-4')}
                </p>
            </div>
        </div>
    </>)
}